import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7e85305c")

_pushScopeId("data-v-7e85305c")
const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-expand-lg navbar-light container justify-content-between"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1)
const _hoisted_3 = {
  class: "nav-link",
  href: "#",
  id: "userOption",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
  })
], -1)
const _hoisted_6 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Reports ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-money-bill-wave-alt" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Manage Assets ")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-exchange-alt" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Manage Pairs ")
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Commercial Groups ")
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-shield" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Permissions ")
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-shield-alt" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Security Options ")
const _hoisted_20 = {
  key: 1,
  class: "dropdown-item bg-success text-white"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Two-factor authentication is enabled ")
const _hoisted_22 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M17,1H7A2,2 0 0,0 5,3V6H7V4H17V20H7V18H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M8.8,11V9.5C8.8,8.1 7.4,7 6,7C4.6,7 3.2,8.1 3.2,9.5V11C2.6,11 2,11.6 2,12.2V15.7C2,16.4 2.6,17 3.2,17H8.7C9.4,17 10,16.4 10,15.8V12.3C10,11.6 9.4,11 8.8,11M7.5,11H4.5V9.5C4.5,8.7 5.2,8.2 6,8.2C6.8,8.2 7.5,8.7 7.5,9.5V11Z"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Enable two-factor authenticator ")
const _hoisted_24 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M7,1A2,2 0 0,0 5,3V7H7V4H17V20H7V17H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1H7M6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C7.31,15 8.42,14.17 8.83,13H11V15H13V13H14V11H8.83C8.42,9.83 7.31,9 6,9M6,11A1,1 0 0,1 7,12A1,1 0 0,1 6,13A1,1 0 0,1 5,12A1,1 0 0,1 6,11Z"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_26 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M18,21L15,18L18,15V17H22V19H18V21M10,4A4,4 0 0,1 14,8A4,4 0 0,1 10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,14C11.15,14 12.25,14.12 13.24,14.34C12.46,15.35 12,16.62 12,18C12,18.7 12.12,19.37 12.34,20H2V18C2,15.79 5.58,14 10,14Z"
  })
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "divider container" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TwoFactorAuthenticator = _resolveComponent("TwoFactorAuthenticator")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode(_component_TwoFactorAuthenticator, {
      show: _ctx.modalShow,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShow = false))
    }, null, 8, ["show"]),
    (_ctx.status == 'success')
      ? (_openBlock(), _createBlock("nav", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode(_component_router_link, { to: { name: 'dashboard' } }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createVNode("a", _hoisted_3, [
            _createVNode("b", null, _toDisplayString(_ctx.userProfile.firstName), 1),
            _hoisted_4,
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: { name: 'report.currency' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: { name: 'currencies.list' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: { name: 'pairs.list' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            }, 8, ["to"]),
            (_ctx.$permissions.generals['comercial_groups'])
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'CommercialGroups.list' },
                  class: "dropdown-item"
                }, {
                  default: _withId(() => [
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: 'permissions.grand' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_15,
                _hoisted_16
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_17,
            _createVNode(_component_router_link, {
              to: { name: 'permissions.security' },
              class: "dropdown-item"
            }, {
              default: _withId(() => [
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            }, 8, ["to"]),
            (_ctx.userProfile.isTwoFactorAuthenticationEnabled)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22
                ]))
              : _createCommentVNode("", true),
            (!_ctx.userProfile.isTwoFactorAuthenticationEnabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  class: "dropdown-item bg-primary text-white",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enable2fa()))
                }, [
                  _hoisted_23,
                  _hoisted_24
                ]))
              : _createCommentVNode("", true),
            _createVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
              class: "dropdown-item pointer"
            }, [
              _hoisted_25,
              _hoisted_26
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_27
  ]))
})